let healthCheckPromise: Promise<boolean> | null = null;
let lastHealthCheck = 0;
const HEALTH_CHECK_CACHE_MS = 2000;

export const checkBackendHealth = async (): Promise<boolean> => {
  const now = Date.now();
  if (healthCheckPromise) return healthCheckPromise;
  if (now - lastHealthCheck < HEALTH_CHECK_CACHE_MS) {
    return healthCheckPromise ?? false;
  }

  healthCheckPromise = performHealthCheck();
  lastHealthCheck = now;
  healthCheckPromise.finally(() => {
    healthCheckPromise = null;
  });
  return healthCheckPromise;
};

export const clearBackendHealthCache = () => {
  healthCheckPromise = null;
  lastHealthCheck = 0;
};

const buildHealthUrl = (path: string): string => {
  const baseUrl = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '');
  return baseUrl ? `${baseUrl}${path}` : path;
};

const fetchHealthStatus = async (path: string): Promise<boolean> => {
  const response = await fetch(buildHealthUrl(path), {
    method: 'GET',
    signal: AbortSignal.timeout(3000),
    headers: { Accept: 'application/json' },
    credentials: 'omit',
  });
  if (!response.ok) return false;
  const data = (await response.json()) as { status?: string };
  return data.status === 'UP';
};

const performHealthCheck = async (): Promise<boolean> => {
  for (const path of ['/actuator/health', '/api/health']) {
    try {
      if (await fetchHealthStatus(path)) return true;
    } catch {
      /* try next */
    }
  }
  return false;
};
